<template>
    <div id="wrap">
        <!-- <MainHeader title='선물 그룹/상품 설정' cart='N'/> -->
        <MainHeader title='' cart='N'/>
        <section>
            <section class="setting_easy">
            <div class="setting_easy_wrap" style="display:none">
                <h4 class="txt-center">
                    선물 받을 분들을 그룹을 나누고<br>
                    그룹별로 선물(1~5개)을 보낼 수 있어요.<br>
                </h4>
                <div class="setting_easy_list" v-for="(group,i) in groupRecoGoods" :key="i" style="display:none">
                    
                    <h5>{{group.group_nm}} <i class="xi-close" style="margin-left:10px;" @click="selectedIndex = i" onclick="modal('reco_setting_03')"></i></h5>
                    <ul class="product_list">
                        <li v-for="reco in recoGoods" :key="reco.good_no" @click="[selectedGroupIndex = i, selectedGoods = reco]" >
                        <div :class="{product_list_box:true, active:group.good_nos.indexOf(reco.good_no) > -1}" :id="`${i}_${reco.good_no}_box`">
                                <a @click="$refs.goodDtl.searchGood($route.params.event_no, reco.good_no, group.good_nos.indexOf(reco.good_no) > -1 ? 1 : 0, 'N')">
                                    <div class="thumb">
                                        <img :src="$store.getters['systemStore/getImgPath']+reco.img_path" :alt="reco.good_nm">
                                    </div>
                                    
                                </a>
                                <label :for="'check'+i+'_'+reco.good_no">
                                <div class="info">
                                        <p>{{reco.good_nm}}</p>
                                        <strong><em>{{reco.sale_price.toLocaleString()}}</em>원</strong>
                                    </div>
                                    </label>
                                <div class="input-form-checkbox">
                                    <input type="checkbox" :id="'check'+i+'_'+reco.good_no" :checked="group.good_nos.indexOf(reco.good_no) > -1" @click.stop="addCart()">
                                    <label :for="'check'+i+'_'+reco.good_no"><i class="xi-check-min" ></i></label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="txt-center"  style="display:none">
                <button class="btn_add_group" @click="addGroup()"><i class="xi-plus-min"></i>그룹추가</button>
            </div>
            </section>
            <Footer/>
        </section>
        <!-- <button class="content_btn" @click="next()" id="recoNextBtn">저장</button> -->
        <GoodDtl ref="goodDtl" :price_hidden="false" @addcart="emitAddCard"/>

        <div class="popup reco_setting_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>{{alertMsg}}</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="modal('reco_setting_01')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>

        <div class="popup reco_setting_02">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="$router.replace('dispGoods')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>

        <div class="popup reco_setting_03">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>해당 그룹과 선택하신 상품을 삭제하시겠습니까?</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="deleteGroupAndGoods()">확 인</button>
                    <button class="btn_large" onclick="modal('reco_setting_03')">취 소</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        <Progress :active="progressActive"/>
        <div :class="{'progress':true, active: active }" id="progress" >
            <div class="dimBg"></div>
            <p>데이터를 불러오는 중입니다.</p>
        </div>
    </div>
</template>
<script>
import MainHeader from '@/components/MainHeader.vue'
import GoodDtl from '@/components/GoodDtl.vue'
import Progress from '@/components/Progress1'
import {api} from '@/api/index.js'
import Footer from '@/components/MainFooter'
export default {
    data() {
        return {
            active: false,
            progressActive: false,
            selectedIndex: 0,
            alertMsg: '',
            good_no: '',
            recoGoods: [], //추천상품
            groupRecoGoods: [
                
                 //그룹명 : "상품1 good_no; 상품2 good_no; ...;"
                 //그룹명 = ascii code 65(A) ~ 90(Z)
                {group_nm: '그룹 A', good_nos: "2117260669;", cnt: 0} //기본
            ],
            nowAscii: 66, //B
            maxAscii: 90, //Z
            selectedGroupIndex: 0,
            selectedGoods: {},
            init_batch_dlv_yn: 'N',
        }
    },
    methods: {
        emitAddCard() {
            this.addCart()
        },

        fnAlert1(msg) {
            this.alertMsg = msg;
            $('.reco_setting_01').addClass('active');
        },
        //그룹 및 상품 삭제
        deleteGroupAndGoods() {
            $('.reco_setting_03').removeClass('active');
            if(this.groupRecoGoods.length === 1) {
                this.fnAlert1('최소 한 개 이상의 그룹이 있어야 합니다.');
                return;
            }
            if(this.selectedIndex === this.groupRecoGoods.length-1) {
                this.nowAscii--;
            }
            this.$delete(this.groupRecoGoods, this.selectedIndex);
            
        },
        addGroup() {
            let newGrp = {};

            if(this.nowAscii > this.maxAscii) {
                this.alertMsg = "더이상 그룹을 추가할 수 없습니다.";
                $('.reco_setting_01').addClass('active');
                return;
            }

            newGrp.group_nm = "그룹 "+String.fromCharCode(this.nowAscii);
            newGrp.good_nos= "";
            newGrp.cnt= 0;
            this.nowAscii++;
            
            this.groupRecoGoods.push(newGrp);
        },
        addCart() {
            let goods = this.selectedGoods;
            //let group_index = this.selectedGroupIndex;
            let group_index = 0;

            console.log(group_index)
            
            
            console.log(this.groupRecoGoods[this.selectedGroupIndex].good_nos.indexOf(goods.good_no))
            //그룹에 상품 존재 여부
            //if(this.groupRecoGoods[this.selectedGroupIndex].good_nos.indexOf(goods.good_no) < 0 ) {

                //this.groupRecoGoods[group_index].good_nos=this.groupRecoGoods[group_index].good_nos.concat(`${goods.good_no};`);
                //this.groupRecoGoods[group_index].cnt++;
            //}
            //else {
               // this.groupRecoGoods[group_index].good_nos = this.groupRecoGoods[group_index].good_nos.replace(`${goods.good_no};`,"");
                //      this.groupRecoGoods[group_index].cnt--;
                //this.groupRecoGoods[group_index].good_nos=this.groupRecoGoods[group_index].good_nos.concat(`${goods.good_no};`);
                this.groupRecoGoods[group_index].cnt++;
            //}

            if(this.groupRecoGoods[group_index].cnt == 6) {
                this.alertMsg = '선물은 5개까지 선택가능합니다.';
                $('.reco_setting_01').addClass('active');

                this.$nextTick(()=> {
                    this.addCart();
                })
            }
        },
        async next(){
           // this.progressActive = true;
            console.log(this.groupRecoGoods)
            if(this.disabled) {
                this.fnAlert1('그룹 당 최소 한 개 이상의 상품이 선택되어야 합니다.');
                this.progressActive = false;
                return;
            }
            for (let group of this.groupRecoGoods) {
                group.event_no = this.$route.params.event_no;
                //[ct-002] 알림톡 즉시 발송 테스트 요건 수정  by, lee.tk - 2021.09.03
                group.batch_dlv_yn  = this.init_batch_dlv_yn;
                await api.postAsync('/group/addGroupAndGoods.do', group);
            }
            // step_divi_cd > wmall-replbox/src/main/java/replbox/util/Const.java 참고
            await api.postAsync('/event/updateEvent.do',{event_no:this.$route.params.event_no, step_divi_cd: '02'})
                    .then(()=> {
                        //this.progressActive = false;
                        this.alertMsg = ' 그룹과 상품이 설정되었습니다. <br/> 다음 단계에서 그룹 변경, 상품 변경 등 수정이 가능합니다.';
                        //$('.reco_setting_02').addClass('active');
                        let url = "dispGoods";
                        if(this.$route.query.searchTerm != undefined) {
                            url = url + "?searchTerm=" + this.$route.query.searchTerm;
                        }
                        this.$router.replace(url);
                    })
                
        }
    },
    computed: {
        disabled() {
            let tf = false;
            for(let group of this.groupRecoGoods) {
                if(group.cnt == 0) {
                    tf = true;
                    break;
                }
            }
            return tf;
        }
    },
    created() {
        this.active = false;
        
        
        api.postAsync('/event/initRecoSetting.do', {event_no: this.$route.params.event_no})
        .then(data=>{

            console.log(data)
            this.recoGoods = data.recoGoods;
            let event = data.event;
            //console.log(init_batch_dlv_yn);
            this.init_batch_dlv_yn = event.init_batch_dlv_yn;
            if(event.step_divi_cd != '01') {
                this.$go(-1);
            }

            this.$nextTick(()=> {
                this.active = false;
            })
        });
        this.addCart();
        this.next();
        
            
    },


    mounted(){
        $(document).ready(function(){
             //   $("#" + tab_id).find(".accodion_tit:first input:radio").prop('checked', true);
           //     $("#" + tab_id).find(".accodion_tit:last").next(".accodion_box").hide();
         //       $("#" + tab_id).find(".accodion_tit:first").next(".accodion_box").show();
         
         });
    }, 


    components: {MainHeader,GoodDtl, Progress,Footer}
}
</script>